const dentalTourism = {
  hero: {
    title: "DENTAL TOURISM IN BULGARIA",
    description:
      "Experience world-class dental care at a fraction of Western prices. Our comprehensive dental tourism packages combine excellent dental treatments with a memorable travel experience.",
    ctas: {
      primary: "Book Free Consultation",
      secondary: "Learn More",
    },
    imageAlt: "Dental Tourism in Bulgaria - Airplane Landing",
  },
  benefits: {
    heading: "WHY CHOOSE US",
    intro:
      "Experience the perfect blend of affordable, high-quality dental care and memorable travel experiences",
    items: [
      {
        title: "Cost Savings",
        description:
          "Save up to 70% on dental procedures compared to Western European and North American prices without compromising on quality.",
      },
      {
        title: "Quality Care",
        description:
          "Our dentists are highly qualified with international training and use the latest dental technology and materials.",
      },
      {
        title: "All-Inclusive Packages",
        description:
          "Comprehensive packages include dental treatment, accommodation, airport transfers, and optional tourism activities.",
      },
      {
        title: "Time Efficiency",
        description:
          "Complex treatments that might take months elsewhere can be completed in a single visit with our efficient scheduling.",
      },
      {
        title: "Cultural Experience",
        description:
          "Combine your dental treatment with an enriching travel experience exploring Bulgaria's rich history and natural beauty.",
      },
      {
        title: "Personalized Care",
        description:
          "Receive individualized attention with dedicated English-speaking staff to guide you through every step of your journey.",
      },
    ],
  },
  process: {
    heading: "HOW IT WORKS",
    intro:
      "Our streamlined dental tourism process makes it easy to receive quality dental care while enjoying a memorable trip to Bulgaria",
    steps: [
      {
        number: "01",
        title: "Initial Consultation",
        description:
          "Contact us for a free online consultation to discuss your dental needs, treatment options, and approximate costs.",
      },
      {
        number: "02",
        title: "Treatment Plan",
        description:
          "We provide a detailed treatment plan with cost estimate and schedule options for your visit to Bulgaria.",
      },
      {
        number: "03",
        title: "Travel Arrangements",
        description:
          "Our coordinators help with flight bookings, accommodation options, and transportation from the airport to your hotel.",
      },
      {
        number: "04",
        title: "Dental Treatment",
        description:
          "Receive high-quality dental care from our experienced specialists in our modern facility in Bulgaria.",
      },
      {
        number: "05",
        title: "Tourism Activities",
        description:
          "Between appointments, explore Bulgaria with our guided tours and experience local culture, cuisine, and attractions.",
      },
      {
        number: "06",
        title: "Follow-up Care",
        description:
          "Return home with your new smile and receive remote follow-up care to ensure your complete satisfaction.",
      },
    ],
  },
  faq: {
    heading: "FREQUENTLY ASKED QUESTIONS",
    intro:
      "Get answers to common questions about our dental tourism services in Bulgaria",
    items: [
      {
        question: "How much can I save with dental tourism in Bulgaria?",
        answer:
          "Patients typically save between 50-70% on dental procedures compared to Western European and North American prices. For example, a dental implant that might cost €3,000 in Western Europe could cost around €900-1,200 in Bulgaria.",
      },
      {
        question: "Are your dentists qualified and experienced?",
        answer:
          "Yes, all our dentists are highly qualified with degrees from prestigious dental schools. Many have international training and certifications, and all stay current with the latest dental techniques and technologies.",
      },
      {
        question: "What languages do your staff speak?",
        answer:
          "Our clinic has English-speaking dentists and staff. We also have translators available for several other languages including German, French, and Russian upon request.",
      },
      {
        question: "How long will I need to stay in Bulgaria for my treatment?",
        answer:
          "The length of stay depends on your specific treatment plan. Simple procedures may require just 2-3 days, while more complex treatments like full mouth rehabilitation might need 7-14 days, often with breaks between appointments.",
      },
      {
        question: "Do you provide accommodation and transportation services?",
        answer:
          "Yes, we offer comprehensive packages that include accommodation recommendations, airport transfers, and transportation to and from the clinic. We can arrange everything according to your preferences and budget.",
      },
      {
        question: "What happens if I need follow-up care after returning home?",
        answer:
          "We provide detailed aftercare instructions before you leave. In case you need assistance, we offer remote consultations via video call. For treatments with warranties, we work with partner clinics in various countries for follow-up care if needed.",
      },
      {
        question: "Is Bulgaria a safe country to visit?",
        answer:
          "Yes, Bulgaria is a safe country with a relatively low crime rate compared to many Western countries. It's a member of the European Union and follows EU standards for healthcare and safety.",
      },
      {
        question: "What tourist attractions can I visit between dental appointments?",
        answer:
          "Bulgaria offers diverse attractions including beautiful Black Sea beaches, mountain resorts, historic towns, ancient Roman ruins, and renowned mineral springs. We can arrange guided tours or provide recommendations based on your interests.",
      },
    ],
    bottomLine: "Still have questions about our dental tourism services?",
    cta: "Book Free Consultation",
  },
};

export default dentalTourism;

